import { useMutation, useQueryClient } from '@tanstack/react-query';

import { CategoryError } from '@/exceptions/category/category.enum';
import { ICategoryDto } from '@/interfaces/entities/category';
import { categoryService } from '@/services/category.service';

const useCreateCategory = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async (category: ICategoryDto) =>
			await categoryService.newCategory(category),

		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['category'] });
		},

		onError: () => {
			throw new Error(CategoryError.CREATE_ERROR);
		},
	});
};

export default useCreateCategory;
